import { render } from "./LabCheckupGuide.vue?vue&type=template&id=7117bc37&scoped=true"
import script from "./LabCheckupGuide.vue?vue&type=script&lang=js"
export * from "./LabCheckupGuide.vue?vue&type=script&lang=js"

import "./LabCheckupGuide.vue?vue&type=style&index=0&id=7117bc37&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7117bc37"]])

export default __exports__